<ng-container *ngIf="!(isPartOfArNavigation$  | async)">
    <div class="alert alert-danger">{{ 'aumico_reports_page_is_not_part_of_ar_navigation' | i18next }}</div>
</ng-container>
<ng-container *ngIf="(isPartOfArNavigation$  | async)" content [ngSwitch]="dataState">
    <div *ngSwitchCase="'loading'">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>

    <ng-container *ngSwitchCase="'success'">
        <fixed-assets-schedule-form
            [fixedAssetsScheduleSavedData]="fixedAssetsScheduleSavedData"
            [fixedAssetsSchedulePreviousYear]="fixedAssetsSchedulePreviousYear"
            [mappingData]="mappedTemplate"
            [balanceOpeningDate]="balanceOpeningDate"
            [balanceClosingDate]="balanceClosingDate"
            [noPreviousData]="noPreviousData"
            [periodStartDate]="periodStartDate"
            [currentLanguage]="currentLanguage"
            [reportLocale]="reportLocale"
            (fixedAssetsScheduleOutput)="onFixedAssetsScheduleOutputChange($event)"
        >
        </fixed-assets-schedule-form>
    </ng-container>

    <div *ngSwitchCase="'error'">
        <div *ngIf="showCompleteDataErrorMessage" class="alert alert-danger">
            {{ localizationKeys.aumico_reports_required_data_not_completed | i18next }}
        </div>
    </div>
    <div *ngSwitchDefault class="alert alert-danger">UNKNOWN STATE</div>
</ng-container>
<ng-template #footerTemplate>
    <aum-action-bar-pure
        [extraActionButtons]="footerExtraButtonActions"
        nextButtonPrefixText="{{nextStepPrefix |  i18next}}"
        nextButtonText="{{nextStepLabel |  i18next}}"
        nextButtonRouterLink="../{{nextStepPath}}"
        [nextButtonAction]="proceedButtonClicked"
        [nextButtonDisabled]="disableProceedButton"
        backButtonPrefixText="{{previousStepPrefix |  i18next}}"
        backButtonText="{{previousStepLabel |  i18next}}"
        backButtonRouterLink="../{{previousStepPath}}"
        [backButtonIcon]="previousStepIcon"
    ></aum-action-bar-pure>
</ng-template>
